import MenuItem from './../../menu/menuItem/MenuItem.vue'
import PopularStreams from './../../popularStreams/PopularStreams.vue'

export default {
  name: 'popular-streams-menu',
  components: {
    MenuItem,
    PopularStreams
  },
}
